import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  CarouselProvider,
} from 'pure-react-carousel';
import cx from 'classnames';
import Modal from '../Modal';
import Carousel from '../Carousel';
import ModalGallery from '../ModalGallery';

import 'pure-react-carousel/dist/react-carousel.es.css';

import './VenueImages.scss';

const VenueImages = ({
  images,
  galleryImages,
  galleryThumbnails,
  venueId,
  isMobile,
  ImageServiceConfig,
}) => {
  const [modalActive, setModalActive] = useState(false);

  const modalStyles = {
    overlay: { backgroundColor: 'rgba(255, 255, 255, 0.95)' },
    content: {
      backgroundColor: 'unset',
      border: 'unset',
      maxWidth: '100%',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 0,
    },
  };

  const toggleModal = () => {
    setModalActive((prevState) => !prevState);
  };

  const renderModal = (imagesArg, thumbnails) => {
    if (imagesArg.length === 0) return null;

    return (
      <Modal
        className="VenueImages__image-modal"
        isOpen={modalActive}
        onRequestClose={toggleModal}
        styles={modalStyles}
        shouldCloseOnEsc
      >
        <CarouselProvider
          touchEnabled
          naturalSlideHeight={isMobile ? 230 : 800}
          naturalSlideWidth={isMobile ? 345 : 800}
          totalSlides={images.length}
          infinite
        >
          <ModalGallery
            slides={imagesArg}
            thumbnails={thumbnails}
            toggleModal={toggleModal}
            isMobile={isMobile}
          />
        </CarouselProvider>
      </Modal>
    );
  };

  const renderImageCarousel = () => {
    const styleObj = isMobile ? { maxWidth: '100vw' } : { maxHeight: '80vh' };

    const slideContent = images.map((image, index) => ({
      type: 'image',
      image,
      alt: `image ${index}`,
    }));

    return (
      <Carousel
        buttonPosition="bottom-right-connected"
        carouselId="venue-images"
        handleSlideClick={toggleModal}
        hasButtons
        hasDotGroup
        ImageServiceConfig={ImageServiceConfig}
        infinite={false}
        isMobile={isMobile}
        slideContent={slideContent}
        step={1}
        styles={styleObj}
        venueId={venueId}
        visibleSlides={1}
        width={800}
      />
    );
  };

  if (images.length < 1) return null;

  return (
    <div
      className={cx('Venue-Images-Container', {
        'Venue-Images-Container--Full-Bleed': isMobile,
        'Venue-Images-Container--Desktop': !isMobile,
      })}
      data-testid="Venue-Images-Container"
    >
      {renderImageCarousel()}

      {modalActive && renderModal(galleryImages, galleryThumbnails)}
    </div>
  );
};

VenueImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
  galleryImages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
  galleryThumbnails: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
  venueId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  ImageServiceConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string,
  }).isRequired,
};

VenueImages.defaultProps = {
  isMobile: false,
};

VenueImages.displayName = 'VenueImages';
export default VenueImages;
